import { atlas } from 'graphql/tags'

export const collectionsQuery = atlas`#graphql
  query CollectionsQueryDupe6(
    $brandIds: [ID!]
    $retailerId: ID!
    ) {
    collections(
      brandIds: $brandIds
      orderBy: { field: NAME }
      filters: { archived: false }
    ) {
      edges {
        node {
          id
          name
          delivery {
            id
            startShipDate
          }
          isVisibleToRetailer(retailerId: $retailerId)
        }
      }
    }
  }
`

export const collectionsOrphanOrderQuery = atlas`#graphql
  query CollectionsOprhanOrderQuery(
    $brandIds: [ID!]
    ) {
    collections(
      brandIds: $brandIds
      orderBy: { field: NAME }
      filters: { archived: false }
    ) {
      edges {
        node {
          id
          name
          delivery {
            id
            startShipDate
          }
        }
      }
    }
  }
`

export const collectionProductsQuery = atlas`#graphql
  query collectionProductsQueryDupe4(
    $first: Int
    $after: String
    $filter: ProductsCollectionFilter
    $brandIds: [ID!]
    $priceTypeId: ID!
  ) {
    collectionProducts(
      first: $first
      after: $after
      filter: $filter
      brandIds: $brandIds
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          product {
            id
            name
            externalIdentifier
            badges {
              edges {
                node {
                  id
                  name
                  image {
                    url
                  }
                }
              }
            }
            traitValues {
              edges {
                node {
                  id
                  trait {
                    id
                    code
                    name
                  }
                  value
                }
              }
            }
            images {
              url
            }
            priceRange(priceTypeId: $priceTypeId) {
              minWholesaleValue
              maxWholesaleValue
              minRetailValue
              maxRetailValue
            }
            skus {
              edges {
                node {
                  id
                }
              }
            }
          }
          collection {
            id
          }
          variants {
            edges {
              values {
                edges {
                  node {
                    id
                    value
                    externalIdentifier
                    trait {
                      id
                      code
                      name
                    }
                    displayDetails {
                      merchandiseImages {
                        url
                      }
                      hexColor
                      swatchImage {
                        url
                      }
                    }
                  }
                }
              }
              node {
                id
                code
                name
              }
            }
          }
        }
      }
    }
  }
`
export const collectionProductsTotalQuery = atlas`#graphql
  query collectionProductsTotalQueryDupe2(
    $filter: ProductsCollectionFilter
    $brandIds: [ID!]
  ) {
    collectionProductsTotal(filter: $filter, brandIds: $brandIds)
  }
`
export const orderVariantTotalsQuery = atlas`#graphql
  query OrderVariantTotalsQueryDupe3(
    $orderIds: [ID!]!
    $filter: OrderVariantTotalsFilter
  ) {
    orderVariantTotals(
      orderIds: $orderIds
      filter: $filter
      limit: 0
      offset: 0
    ) {
      edges {
        node {
          variantId
        }
      }
    }
  }
`
